import React, { useEffect, useRef, useState } from "react";
import BarChart from "./charts/BarChart";
import MBRTable from "./MBRTable";
import PieChart from "./charts/PieChart";
import { useDispatch, useSelector } from "react-redux";
import { fetchAiMbrdData } from "../../../reducers/aiMbrSlice";
import GrievanceBarChart from "./charts/GrievanceBarChart";
// import CaseClosureBarChart from "./charts/CaseClosureBarChart";
import { Button, Tooltip } from "antd";
// import { ArrowUpOutlined } from "@ant-design/icons";
import MissaleComplaintBarChart from "./charts/MissaleComplaintBarChart";
import DynamicBarChart from "./charts/DynamicBarChart";
import ComplaintsTable from "./ComplaintsTable";
import { mbrData } from "../data";

const MBRDashboard = () => {
  const dispatch = useDispatch();
  const graphicalRef = useRef();
  const { data, loading, error } = useSelector((state) => state.aiMbr);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    dispatch(fetchAiMbrdData());

    const scrollContainer = graphicalRef.current;
    if (!scrollContainer) return;

    const handleScroll = () => {
      const scrollHeight = 300;
      setShowScroll(scrollContainer.scrollTop > scrollHeight);
    }

    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    }
  }, [dispatch])

  const scrollTop = () => {
    if (graphicalRef.current) {
      graphicalRef.current.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  }

  // const sections = Object.keys(chartJson); 

  // const yesBankGraph = Object.keys(yesBankChartData);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontWeight: "bold" }}>
        Loading data...
      </div>
    )
  }

  return (
    <>
    {data?.data.MBRdata.map((item) => (
      <section>
        <h4 style={{ marginTop: "0" }}>{item.heading}</h4>
        {item.rows.map((row) => (
          <div style={{ display: "flex",  gap: "5px", marginBottom: "5px", maxWidth: "100%" }}>
            {
              row.map(item => (
                <>
                  {
                    item.type === 'table' && item.subType === 'normal' && 
                    <div style={{ flex: '1 1 auto', maxWidth: "100%", overflowX: "auto" }}>
                      <MBRTable dataSource={item.data} />
                    </div>
                  }
                  {
                    item.type === 'bar' && item.subType === 'compare' && 
                    <div style={{ width: "200px", flex: 1 }}>
                       <DynamicBarChart section={item.title} data={item.data} height={300} />
                    </div>
                  }
                  {
                    item.type === 'table' && item.subType === 'custom' &&
                    <div className="markdown-wrapper" style={{ fontSize: "10px", background: "white", padding: "0 5px 5px 5px", borderRadius: "7px" }}>
                       <ComplaintsTable data={item.data} />
                    </div>
                  }
                  {
                    item.type === 'bar' && item.subType === 'stacked' && 
                    <>
                       <BarChart index="chart-1" dataSource={item.data} title={item.title} />
                    </>
                  }
                  {
                    item.type === 'bar' && item.subType === 'normal' &&
                    <div className="bar-charts grievance" style={{ width: "100%" }}>
                      <GrievanceBarChart
                        index="chart-3"
                        dataSource={item.data}
                        title={item.ittle}
                      />
                    </div>
                  }
                  {
                    item.type === 'pie' && item.subType === 'normal' &&
                    <div className="pie-charts" style={{ flex: 1, maxWidth: "100%" }}>
                      <PieChart
                        title={item.title}
                        dataSource={item.data}
                      />
                    </div>
                  }
                </>
              ))
            }
          </div>
        ))}
      </section>

    ))}
      {/* <section>
        <h4 style={{ marginTop: 0 }}>Overview Of Numbers</h4>
        <MBRTable dataSource={OVERVIEW_OF_NUMBERS} />
      </section>
      <section style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
        <h4>
          Channel Wise MS Complaints Bifurcations Along With Per 10K Details
        </h4>
        <div className="channel-table" style={{ display: "flex", gap: "5px", overflowX: "hidden", width: "100%" }}>
          <MBRTable dataSource={MS_COMPLAINTS_TABLE} width="85%" />
          <MBRTable dataSource={MS_COMPLAINTS_TABLE_2} width="15%" />
        </div>
      </section>

      <section>
        <h4>HDFC BANK</h4>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginBottom: "5px" }}>
          <div style={{ width: "200px", flex: 1 }}>
            {Object.keys(hdfc_Bank_Missale_Complaints).length > 0 && <DynamicBarChart section={"Missale Complaints"} data={hdfc_Bank_Missale_Complaints} height={300} />}
          </div>
          <div style={{ width: "200px", flex: 1 }}>
            {Object.keys(hdfc_Bank_Missale_Complaints).length > 0 && <DynamicBarChart section={"Quarter Wise Complaints"} data={hdfc_Bank_Missale_Complaints} height={300} />}
          </div>

        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginBottom: "5px" }}>
          <div style={{ width: "200px", flex: 1 }}>
            {Object.keys(hdfc_Bank_Missale_Complaints).length > 0 && <DynamicBarChart section={"Sensitive Customer Segment"} data={hdfc_Bank_Missale_Complaints} height={300} />}
          </div>
          <div className="markdown-wrapper" style={{ fontSize: "10px", background: "white", padding: "0 5px 5px 5px", borderRadius: "7px" }}>
            {hdfcbankTableData && <ComplaintsTable data={hdfcbankTableData} />}
          </div>
        </div>
      </section>

      <section>
        <h4>YES BANK</h4>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginBottom: "5px" }}>
        <div style={{ width: "200px", flex: 1 }}>
          {Object.keys(yes_Bank_Missale_Complaints).length > 0 && <DynamicBarChart section={"Missale Complaints"} data={yes_Bank_Missale_Complaints} height={300} />}
        </div>
        <div style={{ width: "200px", flex: 1 }}>
          {Object.keys(yes_Bank_Missale_Complaints).length > 0 && <DynamicBarChart section={"Quarterly Wise Complaints"} data={yes_Bank_Missale_Complaints} height={300} />}
        </div>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginBottom: "5px" }}>
        <div style={{ width: "200px", flex: 1 }}>
          {Object.keys(yes_Bank_Missale_Complaints).length > 0 && <DynamicBarChart section={"Sensitive Customer Segment"} data={yes_Bank_Missale_Complaints} height={300} />}
        </div>
        <div className="markdown-wrapper" style={{ fontSize: "10px", background: "white", padding: "0 5px 5px 5px", borderRadius: "7px" }}>
          {yesbankTableData && <ComplaintsTable data={yesbankTableData} />}
        </div>
      </div>
      </section>

      <section>
        <h4 style={{ marginTop: 0 }}>Servicing Complaints</h4>
        <MBRTable dataSource={CHART_SERVICING_COMPLAINTS} />
      </section>

      <section>
        <h4>Top Areas In Servicing</h4>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginBottom:"5px" }}>

        <div style={{ width: "200px", flex: 1 }}>
          {Object.keys(type_of_complaints).length > 0 && <DynamicBarChart section={"Look In Cancellation"} data={type_of_complaints} height={300} />}
        </div><div style={{ width: "200px", flex: 1 }}>
          {Object.keys(type_of_complaints).length > 0 && <DynamicBarChart section={"Missale"} data={type_of_complaints} height={300} />}

        </div><div style={{ width: "200px", flex: 1 }}>
          {Object.keys(type_of_complaints).length > 0 && <DynamicBarChart section={"Sales Related"} data={type_of_complaints} height={300} />}
        </div><div style={{ width: "200px", flex: 1 }}>
          {Object.keys(type_of_complaints).length > 0 && <DynamicBarChart section={"Unfair Business Practices"} data={type_of_complaints} height={300} />}
        </div>

      </div>
      </section>

      <section>
        <h4>Comparison Of PS and MS Across Fiscal Years</h4>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
          <BarChart index="chart-1" dataSource={CHART_YOY_COMPLAINTS[0]} title="Year on Year Customer Complaints" />
          <BarChart index="chart-2" dataSource={CHART_YOY_COMPLAINTS[1]} title="YTD Customer Complaints" />
        </div>
      </section>



      <section>
        <h4>Servicing Cohort Classification</h4>
        <MBRTable dataSource={SERVICING_COHORT_TABLE_DATA} />
      </section>

      <section>
        <h4>No. Of Premium Paid Details</h4>
        <div className="pie-charts">
          <PieChart
            title="Premiums Paid (Annually)"
            dataSource={NO_PREMIUM_PAID_PIE_CHART}
          />
        </div>
      </section>

      <section>
        <h4>Top products as per contribution</h4>
        <MBRTable dataSource={TOP_PRODUCT_TABLE} />
      </section>

      <section>
        <h4>Grievance Ageing</h4>
        <div className="bar-charts grievance">
          <GrievanceBarChart
            index="chart-3"
            dataSource={GRIEVANCE_AGEING_BAR_GRAPH}
            title="Year on Year Customer Complaints"
          />
        </div>
      </section>


      <section>
        <h4>NB & Active Base both</h4>
        <MBRTable dataSource={PER_10K_TABLE_DATA} />
      </section> */}
    </>
  );
};
export default MBRDashboard;

